module.exports = __webpack_public_path__ + "static/img/5133_phase_function_Paper_Points.ae16d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5133_phase_function_Paper_Points.png
// module id = IcOM
// module chunks = 0